import "./ModalPayProductCommission.scss";

import React, { useMemo, useState } from "react";

import HallAppToast from "../../../commons/HallAppToast";

function toMoney(value) {
  const number = Number(value || 0);

  return number.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

const PAYMENT_METHOD_OPTIONS = [
  { value: "PIX", label: "Pix" },
  { value: "CASH", label: "Dinheiro" },
  { value: "BANK_TRANSFER", label: "Transferência bancária" },
  { value: "DEBIT_CARD", label: "Cartão de débito" },
  { value: "CREDIT_CARD", label: "Cartão de crédito" },
  { value: "OTHER", label: "Outro" },
];

export default function ModalPayProductCommission({
  open,
  employee,
  isLoading = false,
  onClose,
  onConfirm,
}) {
  const [paymentMethod, setPaymentMethod] = useState("PIX");
  const [observation, setObservation] = useState("");

  const pendingAmount = useMemo(
    () => Number(employee?.totalPending || 0),
    [employee]
  );

  if (!open || !employee) {
    return null;
  }

  const handleClose = () => {
    if (isLoading) {
      return;
    }

    setPaymentMethod("PIX");
    setObservation("");
    onClose?.();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!paymentMethod) {
      HallAppToast.info?.("Selecione a forma de pagamento.");
      return;
    }

    if (pendingAmount <= 0) {
      HallAppToast.info?.("Não existe valor pendente para este profissional.");
      return;
    }

    try {
      await onConfirm?.({
        employeeId: employee.employeeId,
        paymentMethod,
        observation: observation?.trim() || null,
      });

      setPaymentMethod("PIX");
      setObservation("");
    } catch (e) {
      // erro tratado pela página
    }
  };

  return (
    <div className="modal-pay-product-commission__overlay" onClick={handleClose}>
      <div
        className="modal-pay-product-commission"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-pay-product-commission__header">
          <div>
            <h3>Confirmar pagamento</h3>
            <p>Revise os dados antes de concluir o pagamento da comissão.</p>
          </div>

          <button
            type="button"
            className="modal-pay-product-commission__close"
            onClick={handleClose}
            disabled={isLoading}
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-pay-product-commission__body">
            <div className="modal-pay-product-commission__summary">
              <div className="modal-pay-product-commission__summary-row">
                <span>Profissional</span>
                <strong>{employee.employeeName}</strong>
              </div>

              <div className="modal-pay-product-commission__summary-row highlight">
                <span>Total pendente</span>
                <strong>{toMoney(pendingAmount)}</strong>
              </div>
            </div>

            <div className="modal-pay-product-commission__field">
              <label htmlFor="paymentMethod">Forma de pagamento</label>
              <select
                id="paymentMethod"
                value={paymentMethod}
                onChange={(e) => setPaymentMethod(e.target.value)}
                disabled={isLoading}
                required
              >
                {PAYMENT_METHOD_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="modal-pay-product-commission__field">
              <label htmlFor="observation">Observação</label>
              <textarea
                id="observation"
                placeholder="Digite uma observação opcional sobre este pagamento"
                value={observation}
                onChange={(e) => setObservation(e.target.value)}
                disabled={isLoading}
                rows={4}
                maxLength={500}
              />
            </div>
          </div>

          <div className="modal-pay-product-commission__footer">
            <button
              type="button"
              className="modal-pay-product-commission__secondary-btn"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancelar
            </button>

            <button
              type="submit"
              className="modal-pay-product-commission__primary-btn"
              disabled={isLoading}
            >
              {isLoading ? "Confirmando..." : "Confirmar pagamento"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}